module.exports = __webpack_public_path__ + "media/newstyle/images/icon-check-white-a04b4ccccbbeb670f24193157c3cc6dd.svg";